
/**
 * 
 * @returns {string} formato fecha ejemplo "dd/MM/yyyy"
 */
export const getFormatDateLocalStorage = () => {

    const hasData = localStorage.getItem("formatFecha_ClassProfesores");

   if (hasData) return hasData;
      
    return "dd/MM/yyyy";
} 